module.exports = __webpack_public_path__ + "media/images/new_landing/case/case-nestle-2-2910dc1d728749c47628436d9bae66df.jpg";